import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { FieldModel, GenericFormService } from "@cv-invision/cv.invision-views.ux";

@Component({
	selector: 'cv-calendar-field',
	templateUrl: './calendar-field.component.html',
	styleUrls: [ './calendar-field.component.scss' ],
})
export class CalendarFieldComponent implements OnInit {

	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	options: any;

	constructor(
		private genericFormService: GenericFormService
	) {
	}

	ngOnInit(): void {
		this.options = this.field.options;
	}

	onClosePanel($event){
		if(this.field.UIEvents?.onClosePanel){
			this.genericFormService.onClosePanel$.next({
				field: this.field,
				fieldOptions: this.fieldOptions,
				event: {
					value: this.control.value
				}
			});
		}
	}
}
